import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Return *url* only if it is a safe http(s) link, else undefined — guards
 * against `javascript:`/`data:` and other unexpected schemes reaching an
 * `href`. Use for any URL that originates from stored/back-end data.
 */
export function safeHttpUrl(url: string | null | undefined): string | undefined {
  if (!url) {
    return undefined;
  }
  try {
    const parsed = new URL(url);
    return parsed.protocol === "http:" || parsed.protocol === "https:" ? url : undefined;
  } catch {
    return undefined;
  }
}
